import "./animation";

// Delay open newsletter popup
jQuery(() => {
  let timeoutId;
  timeoutId = setTimeout(() => {
    $(".delay-open").trigger("click");
  }, 5000);

  const hasCookie =
    document.cookie.split(";").includes(" pum-472=true") ||
    document.cookie.split(";").includes("pum-472=true");

  if (!hasCookie) {
    jQuery(document.body).mousemove(() => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        $(".delay-open").trigger("click");
      }, 5000);
    });
  }
});
